﻿interface NavBarProps {
  onNavigateHome: () => void;
  onNavigateMethodology: () => void;
}

export function NavBar({ onNavigateHome, onNavigateMethodology }: NavBarProps) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0f172a]/90 backdrop-blur-md border-b border-[#1e293b]">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={onNavigateHome}
          className="flex items-center gap-2 text-[#f1f5f9] hover:text-[#60a5fa] transition-colors"
        >
          <svg className="h-6 w-6 text-[#3b82f6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
          <span className="font-[family-name:var(--font-heading)] text-lg font-bold">职途AI</span>
        </button>

        {/* Nav links */}
        <div className="flex items-center gap-6">
          <button
            onClick={onNavigateHome}
            className="text-sm text-[#94a3b8] hover:text-[#f1f5f9] transition-colors font-medium"
          >
            开始评估
          </button>
          <button
            onClick={onNavigateMethodology}
            className="text-sm text-[#94a3b8] hover:text-[#f1f5f9] transition-colors font-medium"
          >
            评估方法
          </button>
        </div>
      </div>
    </nav>
  );
}